document.addEventListener('DOMContentLoaded', function () {
  var forms = document.querySelectorAll('body.template-product form.product-form, body.template-product form[action^="/cart"]');

  forms.forEach(function (form) {
    var addBtn = form.querySelector('button[name="add"], .product-form__submit[name="add"]');
    if (!addBtn) return;

    function isUnavailable() {
      var text = (addBtn.textContent || '').trim().toLowerCase();

      return (
        addBtn.disabled === true ||
        addBtn.getAttribute('aria-disabled') === 'true' ||
        text === 'μη διαθέσιμο' ||
        text === 'not available' ||
        text.indexOf('sold out') !== -1
      );
    }

    function syncQuickBuy() {
      var off = isUnavailable();

      var dynamic    = form.querySelector('.shopify-payment-button');
      var moreOpts   = form.querySelector('.shopify-payment-button__more-options');
      var qtyWrapper = form.querySelector('.product__quantity');
      var qtyInput   = qtyWrapper ? qtyWrapper.querySelector('.js-quantity-input') : null;
      var qtyMinus   = qtyWrapper ? qtyWrapper.querySelector('.js-quantity-btn-minus') : null;
      var qtyPlus    = qtyWrapper ? qtyWrapper.querySelector('.js-quantity-btn-plus') : null;

      if (dynamic)  dynamic.style.pointerEvents  = off ? 'none' : 'auto';
      if (moreOpts) moreOpts.style.pointerEvents = off ? 'none' : 'auto';

      if (qtyMinus) qtyMinus.style.pointerEvents = off ? 'none' : 'auto';
      if (qtyPlus)  qtyPlus.style.pointerEvents  = off ? 'none' : 'auto';

      if (qtyInput) {
        qtyInput.readOnly = off;
        qtyInput.style.pointerEvents = off ? 'none' : 'auto';
      }
    }

    syncQuickBuy();

    var observer = new MutationObserver(syncQuickBuy);
    observer.observe(addBtn, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class'],
      childList: true,
      subtree: true
    });

    form.querySelectorAll('select[name="id"], input[name="id"]').forEach(function (el) {
      el.addEventListener('change', syncQuickBuy);
    });

    var formObserver = new MutationObserver(syncQuickBuy);
    formObserver.observe(form, {
      childList: true,
      subtree: true
    });
  });
});